"use client";

import PublicHeader from "@/components/PublicHeader";
import Footer from "@/components/Footer";
import {
  Container,
  Content,
  ContentWrapper,
  Title,
  Section,
  SectionTitle,
  Paragraph,
  List,
  ListItem,
  Highlight,
} from "./page.styles";

export default function AboutPage() {
  return (
    <Container>
      <PublicHeader />

      <Content>
        <ContentWrapper>
          <Title>About Drizl</Title>

          <Section>
            <Paragraph>
              Welcome to <Highlight>Drizl</Highlight> – the platform connecting
              food lovers with talented local home artisans who create
              authentic, homemade meals with passion and care.
            </Paragraph>
            <Paragraph>
              We believe that the best food comes from the heart, made by people
              who love what they do. That&apos;s why we created Drizl – to
              celebrate home cooking, support local culinary talent, and bring
              communities together through the universal language of food.
            </Paragraph>
          </Section>

          <Section>
            <SectionTitle>Our Story</SectionTitle>
            <Paragraph>
              Drizl was born from a simple idea: what if you could enjoy your
              neighbor&apos;s amazing cooking as easily as ordering from a
              restaurant? We saw incredible culinary talent in our communities –
              home cooks with generations of recipes, passionate food artisans,
              and creative chefs working from home – all looking for a way to
              share their creations with others.
            </Paragraph>
            <Paragraph>
              Traditional food delivery platforms focus on restaurants and
              commercial kitchens. We wanted to create something different – a
              space where home artisans could thrive, where authentic homemade
              meals could reach appreciative customers, and where local
              communities could support each other.
            </Paragraph>
          </Section>

          <Section>
            <SectionTitle>What Makes Us Different</SectionTitle>
            <List>
              <ListItem>
                <strong>Authentic Home Cooking:</strong> Every meal on Drizl is
                made by real people in their home kitchens, not commercial
                facilities. You get the authentic, homemade taste you remember.
              </ListItem>
              <ListItem>
                <strong>Support Local Artisans:</strong> When you order from
                Drizl, you&apos;re directly supporting talented individuals in
                your community, helping them turn their passion into income.
              </ListItem>
              <ListItem>
                <strong>Fresh & Local:</strong> Our artisans prioritize fresh,
                locally-sourced ingredients, creating meals that are better for
                you and better for the environment.
              </ListItem>
              <ListItem>
                <strong>Cultural Diversity:</strong> Experience authentic
                cuisines from around the world, made by artisans who bring their
                cultural heritage and family recipes to every dish.
              </ListItem>
              <ListItem>
                <strong>Community Connection:</strong> Drizl is more than a food
                delivery platform – it&apos;s a way to connect with your
                neighbors, discover hidden culinary talent, and strengthen your
                local community.
              </ListItem>
            </List>
          </Section>

          <Section>
            <SectionTitle>Our Mission</SectionTitle>
            <Paragraph>
              Our mission is to empower home artisans to build successful food
              businesses while providing customers with access to authentic,
              high-quality homemade meals. We&apos;re committed to:
            </Paragraph>
            <List>
              <ListItem>
                Creating economic opportunities for talented home cooks
              </ListItem>
              <ListItem>
                Promoting food diversity and cultural exchange
              </ListItem>
              <ListItem>Supporting sustainable, local food systems</ListItem>
              <ListItem>Building stronger, more connected communities</ListItem>
              <ListItem>
                Making delicious, authentic food accessible to everyone
              </ListItem>
            </List>
          </Section>

          <Section>
            <SectionTitle>Our Vision</SectionTitle>
            <Paragraph>
              We envision a world where anyone with culinary talent can share
              their creations and build a thriving business, where customers can
              easily discover and enjoy authentic homemade meals, and where
              local food communities flourish.
            </Paragraph>
            <Paragraph>
              Through Drizl, we&apos;re not just changing how people access food
              – we&apos;re creating a movement that celebrates home cooking,
              honors culinary traditions, and brings people together through the
              joy of sharing meals.
            </Paragraph>
          </Section>

          <Section>
            <SectionTitle>Join Our Community</SectionTitle>
            <Paragraph>
              Whether you&apos;re a food lover looking for your next favorite
              meal or a talented cook ready to share your creations, Drizl is
              your platform. Join us in celebrating authentic home cooking and
              building stronger local food communities.
            </Paragraph>
            <Paragraph>
              Together, we&apos;re bringing the warmth and authenticity of home
              cooking to every table. Welcome to Drizl – where every meal tells
              a story.
            </Paragraph>
          </Section>
        </ContentWrapper>
      </Content>

      <Footer />
    </Container>
  );
}
